import { useEffect, useMemo } from "react";
import { Link, useParams } from "react-router-dom";

import { NavBar } from "../../../../Models/NavBar/NavBar.Model";
import SequencesModel from "../../../../Models/Sequences/SequencesModel";
import { NameHelper } from "@swivl-mono/helpers";

export function SequenceRecordDetails() {
  const { sequenceUserEvents } = SequencesModel.useState();
  useEffect(() => {
    NavBar.set(
      <NavBar.Component.Back />,
      <NavBar.Component.Title title={"Sequence Record Details"} />,

      // <AgentsOnlineView />,
      null,

      "Sequence Details",
    );

    SequencesModel.load(false);
  }, []);

  const recordId = useParams().recordId;
  const sequenceId = useParams().sequenceId;

  useEffect(() => {
    if (recordId && sequenceId) {
      SequencesModel.loadSequenceRecordsForSequence(parseInt(sequenceId));
      SequencesModel.loadSequenceUserEventsForSequence(parseInt(sequenceId), parseInt(recordId));
    }
  }, [recordId, sequenceId]);

  const userEvents = useMemo(() => {
    if (recordId && sequenceId && sequenceUserEvents) {
      return sequenceUserEvents[parseInt(sequenceId)]?.filter((e) => e.recordId === parseInt(recordId));
    }
    return undefined;
  }, [recordId, sequenceId, sequenceUserEvents]);

  return (
    <div className="p-5">
      <h1>Sequence Record Details</h1>
      {userEvents &&
        userEvents.map((e) => {
          if (!e || !e.user || !e.user.id) {
            console.warn("Invalid user event", e);
            return null;
          }
          return (
            <Link to={`/conversations/all/${e.user.id}`} key={e.id}>
              <div className="SequenceRecordListItem rounded-md bg-white p-3 mb-3 hover:bg-orange-100 flex flex-row justify-between">
                <div className="text-black font-semibold"> {NameHelper.nameForUser(e.user) || "Unknown User"} </div>;
                <div className="float-right">{e.status}</div>
              </div>
            </Link>
          );
        })}
    </div>
  );
}
